import { createSlice, type PayloadAction } from '@reduxjs/toolkit'

type ConfigState = {
  selectedLanguage: string
}

const initialState: ConfigState = {
  selectedLanguage: navigator.language?.startsWith('fr') ? 'fr' : 'en',
}

const slice = createSlice({
  name: 'config',
  initialState,
  reducers: {
    setLanguage(state, { payload }: PayloadAction<string>) {
      state.selectedLanguage = payload
    },
  },
})

export const { setLanguage } = slice.actions
export default slice.reducer
